






















































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import DeviceWaringValuePO from "../../../store/entities/devices/devicewaringvaluepo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Util from "../../../lib/util";
@Component({
  components: { TreeSelect },
})
export default class EditDeviceWaringValue extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  devicewaringvalue: DeviceWaringValuePO = new DeviceWaringValuePO();
  loading: boolean = false;
  create() { }
  created() {
    this.areaTree();
    this.organizetiontree();
  }
  get list() {
    return this.$store.state.devicewaringvalue.list;
  }
  save() {
    (this.$refs.itemForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await this.$store
          .dispatch({
            type: "devicewaringvalue/update",
            data: this.devicewaringvalue,
          })
          .then((e) => {
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
          });
        this.loading = false;
        (this.$refs.itemForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.arealist = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //组织
  async organizetiontree() {
    await this.$store
      .dispatch("organization/getselectTree")
      .then((val) => {
        this.$data.orglist = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  cancel() {
    (this.$refs.itemForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.devicewaringvalue = Util.extend(
        true,
        {},
        this.$store.state.devicewaringvalue.deviceWaringValueItems
      );
      //console.log(this.meterModelPo);
    }
  }
  itemRule = {
    name: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    waringType: [
      {
        type: "number",
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    areaId: [
      {
        type: "number",
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    organizationId: [
      {
        type: "number",
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    t0Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t0Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t1Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t1Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t2Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t2Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t3Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t3Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t4Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t4Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t5Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t5Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t6Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t6Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t7Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t7Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t8Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t8Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t9Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t9Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t10Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t10Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t11Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t11Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t12Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t12Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t13Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t13Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t14Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t14Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t15Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t15Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t16Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t16Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t17Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t17Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t18Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t18Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t19Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t19Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t20Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t20Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t22Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t22Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t23Max: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
    t23Min: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      arealist: [],
      orglist: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
          isDisabled: node.type == 1 ? true : false,
        };
      },
    };
  }
}
